import React, { FormEvent, useState } from 'react'
import { withTranslation } from 'react-i18next'

// @ts-ignore
import Select from 'app/components/Select'
// @ts-ignore
import CheckMark from 'app/components/SVGS/CheckMark'
// @ts-ignore
import Cross from 'app/components/SVGS/Cross'
import ButtonLink from 'app/components/ButtonLink'
import './styles.scss'
import { IRenderSelectProps, ISelectArrayProps } from './interface'
import { List } from 'immutable'

const bc = 'switch-protrack-select-array'

const renderSelect: React.FC<IRenderSelectProps> = ({ setIsOpen, pushToArray, options, disabled }) => {
  let value = options[0]
  return (
    <div className={`${bc}__wrapper`}>
      <Select
        input={{
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            value = e.target.value
          },
        }}
        options={options}
        classNameSelectWrapper={`${bc}__select`}
        showLabel={false}
        disabled={disabled}
      />
      <CheckMark
        onClick={() => {
          pushToArray(value)
          setIsOpen(false)
        }}
      />
    </div>
  )
}

const SelectArray: React.FC<ISelectArrayProps> = ({ fields, options, t, disabled }) => {
  const selectedOptions = fields.getAll()
  const filteredOptions = options.filter((val: string) => {
    return !selectedOptions.includes(val)
  })
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    <div className={`${bc}__selects`}>
      <div className={`${bc}__label`}>{t('admin:Entire Team(s)')}</div>
      {fields.map((member: string, index: number, fields: List<string>) => {
        return (
          <div key={`team-${index}`} className={`${bc}__field`}>
            <div>{fields.get(index)}</div>
            <Cross pathProps={{ fill: '#ff8484' }} onClick={() => fields.remove(index)} />
          </div>
        )
      })}
      {isOpen && renderSelect({ setIsOpen, pushToArray: fields.push, options: filteredOptions, disabled })}
      {!!filteredOptions.length &&
        !disabled && (
          <ButtonLink
            text={`+ ${t('admin:Add another')} ${t('admin:Team').toLowerCase()}`}
            onClick={() => setIsOpen(true)}
          />
        )}
    </div>
  )
}

export default withTranslation()(SelectArray)
